// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Jq-z","imageAndVideoCount":"Kq-z","imageAndVideoContainer":"Lq-z","viewAllReviews":"Mq-z"};